import React from "react";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

export default function PrivacyPage({ navigate }) {
  return (
    <>
      <TopNavbar navigate={navigate} currentPage="" />
      <PageHero className="pageHero">
        <div className="container">
          <h1 className="font40 extraBold darkColor heroTitle">מדיניות פרטיות</h1>
          <p className="font15 darkColor" style={{ marginTop: "10px", opacity: 0.9 }}>
            עודכן לאחרונה: 23.10.2026
          </p>
        </div>
      </PageHero>

      <PageBody>
        <div className="container">
          <Section>
            <h2 className="font25 extraBold darkColor">1. כללי</h2>
            <BodyText>
              ברוכה הבאה לאתר הלב הצבעוני (להלן: "האתר"). אנו מכבדות את פרטיותך ומחויבות
              להגן על המידע האישי שאת משתפת איתנו.
              מדיניות זו מסבירה אילו נתונים אנו אוספים, כיצד אנו משתמשים בהם ומהן זכויותיך.
              השימוש באתר מהווה הסכמה למדיניות פרטיות זו.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">2. מידע שאנו אוספים</h2>
            <BodyText>אנו אוספים מידע שאת מוסרת לנו מרצונך החופשי, ובין היתר:</BodyText>
            <List>
              <li><strong>שם מלא</strong>: בעת מילוי טופס יצירת קשר או הרשמה לסדנה.</li>
              <li><strong>כתובת אימייל</strong>: לצורך חזרה אלייך ושליחת עדכונים.</li>
              <li><strong>מספר טלפון</strong>: אם בחרת לשתף אותו.</li>
              <li><strong>תוכן ההודעה</strong>: שאת כותבת בטופס יצירת הקשר.</li>
            </List>
            <BodyText style={{ marginTop: "16px" }}>
              בנוסף, ייתכן שיאסף מידע טכני אוטומטי כגון: כתובת IP, סוג דפדפן, מכשיר,
              ועמודים שביקרת בהם, באמצעות כלים כמו Google Analytics.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">3. מטרות השימוש במידע</h2>
            <BodyText>המידע שנאסף ישמש אך ורק למטרות הבאות:</BodyText>
            <List>
              <li>חזרה אלייך בתגובה לפניה שיצרת.</li>
              <li>שליחת פרטים על סדנאות ואירועים, אם ביקשת זאת.</li>
              <li>שיפור חוויית השימוש באתר.</li>
              <li>עמידה בדרישות חוקיות.</li>
            </List>
            <BodyText style={{ marginTop: "16px" }}>
              אנו <strong>לא</strong> נשתמש במידע שלך לצרכי פרסום של צד שלישי,
              ו<strong>לא</strong> נמכור אותו לאף גורם.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">4. שיתוף מידע עם צדדים שלישיים</h2>
            <BodyText>
              אנו לא מוכרים, סוחרים או מעבירים את פרטייך האישיים לגורמים חיצוניים,
              למעט במקרים הבאים:
            </BodyText>
            <List>
              <li>
                <strong>ספקי שירות טכניים</strong>: כגון ספק האחסון של האתר, אשר פועלים
                מטעמנו ומחויבים לשמירה על סודיות.
              </li>
              <li>
                <strong>Google Analytics</strong>: לניתוח תנועה באתר (מידע אנונימי בלבד).
                ניתן לבטל מעקב זה דרך{" "}
                <ExternalLink href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
                  הכלי של Google
                </ExternalLink>.
              </li>
              <li>
                <strong>דרישה חוקית</strong>: אם נידרש לכך על פי חוק או צו שיפוטי.
              </li>
            </List>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">5. עוגיות (Cookies)</h2>
            <BodyText>
              האתר עשוי להשתמש בעוגיות (קבצים קטנים הנשמרים בדפדפן שלך) לצורך
              שיפור חוויית הגלישה וניתוח סטטיסטי. ביקורך הראשון באתר מלווה בבקשת הסכמה.
              תוכלי לנהל או לחסום עוגיות בהגדרות הדפדפן שלך.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">6. אבטחת מידע</h2>
            <BodyText>
              אנו נוקטים אמצעים סבירים להגנה על המידע שאת מוסרת לנו, לרבות שימוש
              בחיבור מוצפן (HTTPS). יחד עם זאת, אין אפשרות להבטיח אבטחה מלאה בכל עת
              ואיננו אחראים לפרצות אבטחה שאינן בשליטתנו.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">7. זכויותייך</h2>
            <BodyText>בהתאם לחוק הגנת הפרטיות, התשמ"א–1981, יש לך זכות:</BodyText>
            <List>
              <li>לעיין במידע שנשמר עלייך.</li>
              <li>לבקש תיקון מידע שגוי.</li>
              <li>לבקש מחיקת המידע שלך ממאגרינו.</li>
              <li>לבטל בכל עת הסכמה לקבלת עדכונים בדואר אלקטרוני.</li>
            </List>
            <BodyText style={{ marginTop: "16px" }}>
              לכל בקשה בנושא פרטיות ניתן לפנות אלינו בכתובת:{" "}
              <strong>carmela0208@gmail.com</strong>
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">8. שינויים במדיניות</h2>
            <BodyText>
              אנו שומרות לעצמנו את הזכות לעדכן מדיניות פרטיות זו מעת לעת.
              שינויים מהותיים יפורסמו באתר. המשך השימוש באתר לאחר פרסום השינויים
              מהווה הסכמה למדיניות המעודכנת.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">9. יצירת קשר</h2>
            <BodyText>
              לשאלות ופניות בנושא פרטיות:{" "}
              <strong>carmela0208@gmail.com</strong>
            </BodyText>
          </Section>

          <BackBtn onClick={() => navigate("home")} className="pinkBg whiteColor radius8 pointer semiBold font15">
            חזרה לדף הבית
          </BackBtn>
        </div>
      </PageBody>

      <Footer navigate={navigate} />
    </>
  );
}

const PageHero = styled.section`
  padding: 120px 0 40px;
  direction: rtl;
`;
const PageBody = styled.div`
  padding: 60px 0 80px;
  direction: rtl;
`;
const Section = styled.div`
  margin-bottom: 10px;
`;
const BodyText = styled.p`
  margin-top: 12px;
  line-height: 1.9;
  color: var(--ink-soft);
  font-size: 0.938rem;
`;
const List = styled.ul`
  list-style: disc;
  padding-right: 24px;
  margin-top: 12px;
  li {
    margin-bottom: 8px;
    line-height: 1.8;
    color: var(--ink-soft);
    font-size: 0.938rem;
  }
`;
const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--rose-200);
  margin: 30px 0;
`;
const ExternalLink = styled.a`
  color: var(--rose-600) !important;
  text-decoration: underline !important;
`;
const BackBtn = styled.button`
  margin-top: 40px;
  padding: 14px 30px;
  font-size: 1rem;
  border: none;
  cursor: pointer;
`;
